export const buildEventJsonLd = ({
  name,
  description,
  url,
  imageUrl,
  startDate,
  endDate,
  locationName,
}: {
  name: string
  description?: string
  url: string
  imageUrl?: string
  startDate?: string
  endDate?: string
  locationName?: string
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Event',
  name,
  description,
  url,
  image: imageUrl,
  startDate,
  endDate,
  location: locationName
    ? {
        '@type': 'Place',
        name: locationName,
      }
    : undefined,
})
